<div class="grid mx-2 flex align-items-center" *ngIf="onExtendedMobile()">
	<div class="col-1"></div>
	<div class="col-10">
		<div class="flex justify-content-center text-xl font-bold">
		{{ titleId | translate }}
		</div>
	</div>
	<div class="col-1">
		<app-permissions-button-bar class="flex justify-content-end"></app-permissions-button-bar>
	</div>
</div>
<div class="layout-content p-0" [ngClass]="layoutMarginResponsive()">
	<div class="grid">
		<app-site-selector [class]="!onExtendedMobile() ? 'col-9' : 'col-12'"></app-site-selector>
		<app-permissions-button-bar *ngIf="!onExtendedMobile()" class="col-3 flex align-items-center justify-content-end"></app-permissions-button-bar>
	</div>
	<div class="grid p-0 px-2 mb-5 lg:mb-3 mt-0 md:p-1">
		<div class="col-12">
			<app-permissions-tab-group></app-permissions-tab-group>
		</div>
	</div>
</div>